import { useState } from 'react';
import { AccordionHeader } from '../molecules/AccordionHeader';
import { AccordionProps } from '@/shared/types/accordion';
import { AccordionContent } from '../molecules/AccordionContent';

export const AccordionContainer = ({
  title,
  subtitle,
  children,
  id,
  className,
  headerClassName,
  defaultOpen = false,
  disabled = false,
}: AccordionProps) => {
  // Validación de props en desarrollo
  if (process.env.NODE_ENV !== 'production') {
    if (!title) {
      // eslint-disable-next-line no-console
      console.warn('Accordion: title prop is required');
    }
    if (!id) {
      // eslint-disable-next-line no-console
      console.warn('Accordion: id prop is required');
    }
  }

  const [open, setOpen] = useState<boolean>(defaultOpen);

  // Validación mejorada de children
  const hasContent = children !== null && children !== undefined && children !== false;

  const headerId = `${id}-header`;
  const contentId = `${id}-content`;

  return (
    <div
      className={`ui-imj ui-box-border ui-flex ui-w-full ui-flex-col ui-items-start ui-gap-12 ui-overflow-hidden ui-rounded-surface-card ui-border-1 ui-border-default ui-p-12 ${
        disabled || !hasContent
          ? 'ui-border-disabled ui-bg-surface-disabled'
          : 'ui-border ui-bg-surface'
      } ${className || ''}`}
    >
      <AccordionHeader
        id={headerId}
        open={open}
        title={title}
        subtitle={subtitle}
        setOpen={setOpen}
        className={headerClassName}
        children={children}
        disabled={disabled}
        ariaControls={contentId}
      />

      <AccordionContent open={open} id={contentId} ariaLabelledBy={headerId}>
        {children}
      </AccordionContent>
    </div>
  );
};
